import { type OnboardingStepState } from "@/lib/api";

import { AppBar, PillButton } from "./components";
import { STEP_CONTENT } from "./step-content";

interface ModuleScreenProps {
  step: OnboardingStepState;
  busy: boolean;
  error: string;
  onComplete: () => void;
}

/**
 * Placeholder module detail — each module's real multi-screen phase gets
 * designed in the upcoming Figma passes; this keeps the flow walkable.
 */
export function ModuleScreen({ step, busy, error, onComplete }: ModuleScreenProps) {
  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[390px] flex-col bg-white">
      <AppBar title={step.title} />
      <div className="flex flex-1 flex-col gap-4 px-6 pt-6">
        <h1 className="text-primary type-title">{step.title}</h1>
        <p className="text-muted text-[17px] leading-6">
          {STEP_CONTENT[step.key] ?? "Follow the instructions in your Quick Start Guide."}
        </p>
      </div>
      <div className="flex flex-col gap-3 px-6 pb-10">
        {error && (
          <p role="alert" className="text-destructive text-center text-[15px]">
            {error}
          </p>
        )}
        <PillButton label="Mark as done" busy={busy} onClick={onComplete} />
      </div>
    </div>
  );
}
